import {
  Modal,
  ModalContent,
  ModalContentBody,
  Text,
} from "@zapier/design-system";

import EditDescriptionModalContent from "./EditDescriptionModalContent";
import { useAtomValue } from "jotai";
import { canvasAtom } from "@zapier/canvas-state";

type Props = {
  onClosed: () => void;
};

export function EditDescriptionModal({ onClosed }: Props) {
  const canvas = useAtomValue(canvasAtom);
  const header = canvas?.description ? "Update description" : "Add description";

  return (
    <Modal onClosed={onClosed} aria-label={header}>
      <ModalContent>
        <Text type="SectionHeader" margin="0 0 23px 0">
          {header}
        </Text>
        <ModalContentBody>
          <EditDescriptionModalContent onClosed={onClosed} />
        </ModalContentBody>
      </ModalContent>
    </Modal>
  );
}
